export default __webpack_public_path__ + "static/media/year.656995c3.svg";